export const BREAK_CARDS = {
    'fibroadenoma': 1,
    'opacity': 2,
}


export const COLORS_MAP = {
    'AUSENTE': 'bg-gray-500',
    'PEQUENO': 'bg-yellow-400',
    'MODERADO': 'bg-orange-500',
    'GRAVE': 'bg-red-600',
    'ARCO COSTAL': 'bg-blue-500',
    'CLAVÍCULA': 'bg-purple-500',
    'AMBOS': 'bg-pink-500',
    'BAIXA': 'bg-green-500',
    'MODERADA': 'bg-yellow-500',
    'ALTA': 'bg-red-500',
    'BENIGNA': 'bg-green-400',
    'SUSPEITA': 'bg-yellow-600',
    'PRESENTE': 'bg-emerald-500',
    'SUSPEITO': 'bg-amber-600',
    'A': 'bg-blue-400',
    'B': 'bg-indigo-500',
    'C': 'bg-purple-500',
    'D': 'bg-violet-600',
    'PERFEITA': 'bg-green-600',
    'BOA': 'bg-lime-500',
    'INADEQUADA': 'bg-red-400',
    '0': 'bg-slate-500',
    '1': 'bg-blue-500',
    '2': 'bg-cyan-500',
    '3': 'bg-yellow-500',
    '4': 'bg-orange-500',
    '5': 'bg-red-500'
}


export const serviceOptions = {
    cxr: { name: 'CXR', iconPath: '/public/assets/icons/icon-cxr.svg' },
    do: { name: 'DXA', iconPath: '/public/assets/icons/icon-dxa.svg' },
    mammo: { name: 'MAMMO', iconPath: '/public/assets/icons/icon-mammo.svg' },
    mskxr: { name: 'MSKXR', iconPath: '/public/assets/icons/icon-mskxr.svg' },
    cct: { name: 'CCT', iconPath: '/public/assets/icons/icon-cct.svg' },
    // hct: { name: 'HCT', iconPath: '/public/assets/icons/icon-hct.svg' },
};

export const modalityKeys = Object.values(serviceOptions).map(service => service.name.toLowerCase());

export function getDefaultDetailedData() {
    const defaultDetailedData = modalityKeys.reduce((acc, key) => {
        acc[key] = {
            total_objects: 0,
            objects_with_errors: 0,
            objects_without_errors: 0,
            findings: {}
        };
        return acc;
    }, {});
    return defaultDetailedData;
}

export const statusOptions = {
    'Não visualizado': { name: 'Não visualizado', iconPath: '/public/assets/icons/icon-eye-slash.svg' },
    'Visualizado': { name: 'Visualizado', iconPath: '/public/assets/icons/icon-eye.svg' },
    'Editado': { name: 'Editado', iconPath: '/public/assets/icons/icon-check.svg' },
};
